import { Action } from '../types';
import { useAppDispatch } from '../stores/redux.store';
import { useAwsCaptchaSuccessCallbackRef } from './aws-captcha-success-callback-context';
import { useCallback } from 'react';

export const openAwsCaptchaModal = (): Action => ({
  type: 'OPEN_AWS_CAPTCHA_MODAL',
});

export const closeAwsCaptchaModal = (): Action => ({
  type: 'CLOSE_AWS_CAPTCHA_MODAL',
});

/**
 * Returns a function that opens the AWS Captcha modal and stores the onSuccess
 * callback in the shared CaptchaCallbackContext ref so it can be invoked by
 * AWSWafCaptchaComponent when the puzzle is completed.
 *
 * The callback is not stored in Redux (non-serialisable) — it lives in a
 * MutableRefObject provided by CaptchaCallbackProvider.
 */
export const useOpenAwsCaptchaModalFunction = () => {
  const dispatch = useAppDispatch();
  const successCallbackRef = useAwsCaptchaSuccessCallbackRef();

  return useCallback(
    ({ onSuccess }: { onSuccess: () => void }) => {
      successCallbackRef.current = onSuccess;
      dispatch(openAwsCaptchaModal());
    },
    [dispatch, successCallbackRef]
  );
};
